import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f97f8124"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "column-similar" }
const _hoisted_2 = { class: "flex-bwn similar-type" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "similar-list" }
const _hoisted_5 = { class: "rel pop flex-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "abs-wrap" }, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "rel"
}
const _hoisted_8 = {
  key: 1,
  class: "rel"
}

import { ref, watch, onMounted } from 'vue'
import { t } from '@/plugins/i18n'
import { searchSimilar, searchSimilarShop, searchList, searchUpload } from '@/apis/search'
import PopBtn from '@/components/common/PopBtn.vue'
import GoodsLink from '@/components/common/GoodsLink.vue'
import Image from '@/components/common/Image.vue'
import { showCurrentUnit } from '@/util/useYan'

import { useRtfix } from '@/store'
import { urlToBase64 } from '@/util/useSearchByImage'

export default /*#__PURE__*/_defineComponent({
  props: ['product'],
  setup(__props) {

const props = __props


const Types = [{ label: '同款商品' }, { label: '相似店铺' }].fort()
const type = ref(0)

const data: any = ref([])
const imageId = ref('')
const loading = ref(false)
watch([() => props.product, type], async ([v, type]) => {
  imageId.value = ''
  data.value = []
  loading.value = true
  const apis = type ? searchSimilarShop : searchList
  const params = { imageUrl: props.product.productMainImg, imageBase64: '' }
  try {
    if (!imageId.value) {
      const res = await urlToBase64(props.product.productMainImg)
      res && (params.imageBase64 = res.split(',')[1])
      imageId.value = (await searchUpload(params)).data
    }
  } catch (error) {

  } finally {
    const t = type ? { shopCode: v.shopCode } : { productCode: v.productCode }
    apis({
      ...t,
      imageId: imageId.value,
      imageUrl: v.productMainImg,
      pageSize: 5,
      pageNum: 1
    }).then((res) => {
      if (res.success) {
        data.value = res.data.records
          .filter((v: any) => v.productMainImg || v.shopMainImg)
          .slice(0, 4)
      }
      loading.value = false
    })
  }
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(Types), (v, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["btn", { active: i === type.value }]),
          key: i,
          onClick: ($event: any) => (type.value = i)
        }, _toDisplayString(v.label), 11, _hoisted_3))
      }), 128))
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (v) => {
        return (_openBlock(), _createBlock(PopBtn, {
          key: v.shopCode,
          always: "",
          class: "flex btn"
        }, {
          pop: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              (!type.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(v.productSellPrice) + _toDisplayString(_unref(showCurrentUnit)(v.currency === 'KRW')), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(v.shopName), 1))
            ])
          ]),
          default: _withCtx(() => [
            (!type.value)
              ? (_openBlock(), _createBlock(GoodsLink, {
                  key: 0,
                  goods: v,
                  style: {"min-height":"119px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(Image, {
                      referrerPolicy: "no-referrer",
                      "data-goods": "",
                      src: v.productMainImg,
                      alt: ""
                    }, null, 8, ["src"])
                  ]),
                  _: 2
                }, 1032, ["goods"]))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: _unref(useRtfix)('list', { query: { shopCode: v.shopCode } })
                }, {
                  default: _withCtx(() => [
                    _createVNode(Image, {
                      referrerPolicy: "no-referrer",
                      "data-goods": "",
                      src: v.shopMainImg,
                      alt: ""
                    }, null, 8, ["src"])
                  ]),
                  _: 2
                }, 1032, ["to"]))
          ]),
          _: 2
        }, 1024))
      }), 128))
    ], 512), [
      [_directive_loading, loading.value]
    ]),
    _withDirectives(_createVNode(_component_router_link, {
      to: _unref(useRtfix)('list', { query: { imageUrl: __props.product.productMainImg, imageId: imageId.value } })
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('查看更多')), 1)
      ]),
      _: 1
    }, 8, ["to"]), [
      [_vShow, !type.value && data.value.length]
    ])
  ]))
}
}

})